import { PropsWithChildren } from 'react';
import { ErrorCard, ErrorCardProps } from '../cards';
import { FlexBox, FlexBoxProps } from '../layout';

type ErrorPageProps = FlexBoxProps & {
  cardProps?: ErrorCardProps;
};

const ErrorPage: React.FC<PropsWithChildren<ErrorPageProps>> = ({
  cardProps,
  children,
  ...props
}) => (
  <FlexBox
    flexDirection={'column'}
    height="80vh"
    width="100%"
    alignItems={'center'}
    justifyContent={'center'}
    {...props}
  >
    <ErrorCard {...cardProps}>{children}</ErrorCard>
  </FlexBox>
);
export default ErrorPage;
